import React from "react";

import PostHeader from "./Header";

function Post({ children }) {
 return (
  <article className="post">
   <PostHeader />
   <div className="post__content">{children}</div>
  </article>
 );
}

export default Post;
